// Responsive utility functions and breakpoint definitions
export const breakpoints = {
  xs: 320,   // Small phones
  sm: 640,   // Large phones
  md: 768,   // Tablets
  lg: 1024,  // Small laptops
  xl: 1280,  // Desktops
  '2xl': 1536 // Large desktops
};

// Fluid typography scale
export const getFluidTypography = (screenSize) => {
  const scales = {
    xs: {
      h1: 'text-4xl',      // 36px
      h2: 'text-3xl',      // 30px
      h3: 'text-2xl',      // 24px
      h4: 'text-xl',       // 20px
      body: 'text-base',   // 16px
      small: 'text-sm'     // 14px
    },
    sm: {
      h1: 'text-5xl',      // 48px
      h2: 'text-4xl',      // 36px
      h3: 'text-3xl',      // 30px
      h4: 'text-xl',       // 20px
      body: 'text-lg',     // 18px
      small: 'text-base'   // 16px
    },
    md: {
      h1: 'text-6xl',      // 60px
      h2: 'text-5xl',      // 48px
      h3: 'text-3xl',      // 30px
      h4: 'text-2xl',      // 24px
      body: 'text-lg',     // 18px
      small: 'text-base'   // 16px
    },
    lg: {
      h1: 'text-7xl',      // 72px
      h2: 'text-6xl',      // 60px
      h3: 'text-4xl',      // 36px
      h4: 'text-2xl',      // 24px
      body: 'text-xl',     // 20px
      small: 'text-lg'     // 18px
    },
    xl: {
      h1: 'text-8xl',      // 96px
      h2: 'text-7xl',      // 72px
      h3: 'text-5xl',      // 48px
      h4: 'text-3xl',      // 30px
      body: 'text-xl',     // 20px
      small: 'text-lg'     // 18px
    },
    '2xl': {
      h1: 'text-9xl',      // 128px
      h2: 'text-8xl',      // 96px
      h3: 'text-6xl',      // 60px
      h4: 'text-4xl',      // 36px
      body: 'text-2xl',    // 24px
      small: 'text-xl'     // 20px
    }
  };

  return scales[screenSize] || scales.lg;
};

// Responsive spacing system
export const getResponsiveSpacing = (screenSize) => {
  const spacing = {
    xs: {
      section: 'py-12 px-4',
      container: 'px-4',
      gap: 'gap-4',
      mb: 'mb-8'
    },
    sm: {
      section: 'py-16 px-6',
      container: 'px-6',
      gap: 'gap-6',
      mb: 'mb-12'
    },
    md: {
      section: 'py-20 px-8',
      container: 'px-8',
      gap: 'gap-8',
      mb: 'mb-16'
    },
    lg: {
      section: 'py-24 px-6',
      container: 'px-6',
      gap: 'gap-12',
      mb: 'mb-20'
    },
    xl: {
      section: 'py-28 px-6',
      container: 'px-6',
      gap: 'gap-16',
      mb: 'mb-24'
    },
    '2xl': {
      section: 'py-32 px-6',
      container: 'px-6',
      gap: 'gap-20',
      mb: 'mb-28'
    }
  };

  return spacing[screenSize] || spacing.lg;
};

// Animation duration based on screen size
export const getAnimationDuration = (screenSize) => {
  const durations = {
    xs: 0.3,   // Faster on mobile
    sm: 0.4,
    md: 0.5,
    lg: 0.6,
    xl: 0.7,
    '2xl': 0.8
  };

  return durations[screenSize] || 0.6;
};